import type { ReactNode } from 'react'
import './demos.css'

/**
 * The wrapper every section demo sits in.
 *
 * `aria-hidden` because the `lede` carries the meaning for screen readers — a frozen fixture card
 * read aloud is noise. `inert` because the real components inside are still real: they have
 * buttons, and an aria-hidden subtree with focusable children is a trap. Together they make the
 * demo exactly what it claims to be: a picture of the UI, not the UI.
 */
export default function DemoFrame({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={`rules-demo ${className ?? ''}`} aria-hidden="true" inert>
      {children}
    </div>
  )
}
